import { StoryLayout } from '@/interface';

export enum FormOption {
  DRAFT = 0, // 保存草稿
  SUBMIT = 1, // 正式提交
  JUMP = 2, // 跳转
  SUBMIT_NEXT = 3, // 提交并跳转到下一页
  SUBMIT_PRE = 4, // 提交草稿并跳转到上一页
  SAVE_TO_SUBMIT_NEXT = 5, // 保存并提交并跳转到下一页


  AUTO_SAVE = 6, // 自动保存
  EVENT_SAVE = 7, // 事件触发保存
  PUBLISH = 8, //  发布
  FORCE_SAVE = 9,
  TAB = 10,
}

export const SAVE_TO_DRAFT = {
  type: FormOption.DRAFT,
  value: true,
};

export const SAVE_TO_SUBMIT = {
  type: FormOption.SUBMIT,
  value: true,
};
export const SAVE_TO_TAB = {
  type: FormOption.TAB,
  value: true,
};

export const SAVE_TO_JUMP = {
  type: FormOption.JUMP,
  value: true,
};

export const SAVE_TO_SUBMIT_NEXT = {
  type: FormOption.SUBMIT_NEXT,
  value: true,
};

export const SAVE_TO_SUBMIT_PRE = {
  type: FormOption.SUBMIT_PRE,
  value: true,
};

export const SAVE_TO_PUBLISH = {
  type: FormOption.PUBLISH,
  value: true,
};

export const getSaveTip = (type?: FormOption, name?: string) => {
  if (type === FormOption.DRAFT) {
    return {
      success: `${name || ''}保存成功`,
      error: `${name || ''}保存失败`,
      isDraft: true,
      isAutoSave: false,
    };
  }

  if (type === FormOption.AUTO_SAVE) {
    return {
      success: `${name || ''}自动保存成功`,
      error: `${name || ''}自动保存失败`,
      isDraft: false,
      isAutoSave: true,
    };
  }

  if (type === FormOption.PUBLISH) {
    return {
      success: `${name || ''}发布成功`,
      error: `${name || ''}发布失败`,
      isDraft: false,
      isAutoSave: false,
    };
  }

  return {
    success: `${name || ''}保存成功`,
    error: `${name || ''}保存失败`,
    isDraft: false,
    isAutoSave: false,
  };
};

export const LIMIT_PIC = {
  type: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
  uploadType: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  size: 4,
};

export const PICBOOK_IMAGE_SIZE = 16;

export const ALERT_IMAGE = {
  [StoryLayout.LAYOUT_VERTICAL]: `竖版 9:16，大小 ≤ ${LIMIT_PIC.size}M`,
  [StoryLayout.LAYOUT_HORIZONTAL]: `横版 812x375，大小 ≤ ${LIMIT_PIC.size}M`,
};

export const LIMIT_AUDIO = {
  type: ['mp3', 'wav'],
  uploadType: ['audio/mpeg', 'audio/wav'],
  size: 100,
};

export const LIMIT_VIDEO = {
  type: ['mp4', 'mov'],
  uploadType: ['video/mp4', 'video/quicktime'],
  size: 100,
};

export const MAX_UPLOAD_SIZE = 100; // 上传COS时的最大文件大小

export const AUDIO_ALERT = `格式：${LIMIT_AUDIO.type.join('、')}，文件大小 ≤ ${LIMIT_AUDIO.size}M`;

export const VIDEO_ALERT = `格式：${LIMIT_VIDEO.type.join('、')}，文件大小 ≤ ${LIMIT_VIDEO.size}M`;
